import { twMerge } from "tailwind-merge";
import { useMemo } from "react";

function SchedulingQuarterFilledIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
      <path d="M12 12 L12 2 A10 10 0 0 1 22 12 Z" fill="currentColor" />
    </svg>
  );
}

function SchedulingHalfFilledIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
      <path d="M12 2 A10 10 0 0 1 12 22 L12 2 Z" fill="currentColor" />
    </svg>
  );
}

function SchedulingThreeQuartersFilledIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
      <path d="M12 12 L12 2 A10 10 0 1 1 2 12 L12 12 Z" fill="currentColor" />
    </svg>
  );
}

export function SchedulingCheckmarkIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <path
        d="M8 12.5 L11 15.5 L16 9.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export type Props = {
  className?: string;
  duration: number;
};

export function SchedulingTimeSlotDurationIcon({ className, duration }: Props) {
  const icon = useMemo(() => {
    if (duration >= 2) {
      return <SchedulingCheckmarkIcon />;
    } else if (duration >= 1.5) {
      return <SchedulingThreeQuartersFilledIcon />;
    } else if (duration >= 1) {
      return <SchedulingHalfFilledIcon />;
    } else {
      return <SchedulingQuarterFilledIcon />;
    }
  }, [duration]);

  return (
    <span
      className={twMerge(
        "flex-shrink-0",
        "text-brand-300",
        duration >= 2 && "text-brand-600",
        className
      )}
    >
      {icon}
    </span>
  );
}

export default SchedulingTimeSlotDurationIcon;

